const VARIABLE_SOURCE = String.raw`\{\{\s*[^{}]+?\s*\}\}`;
// Sticky: matches only when a {{ variable }} begins at the given position, so we
// can step through the JSON. Global: matches every variable, for replace-all.
const VARIABLE = new RegExp(VARIABLE_SOURCE, 'y');
const VARIABLES = new RegExp(VARIABLE_SOURCE, 'g');

export const isJsonTemplateValid = (value: string): boolean => {
  const trimmed = value.trim();
  if (trimmed === '') {
    return true;
  }
  // A variable can stand in for any JSON value, so blank each one to a literal
  // before checking the structure parses.
  const candidate = trimmed.replace(VARIABLES, 'null');
  try {
    JSON.parse(candidate);
    return true;
  } catch {
    return false;
  }
};

// Pretty-prints JSON that may contain {{ variable }} references. A variable
// inside a string is already valid text; only a value-position one breaks the
// JSON, so it gets a placeholder that's swapped back after formatting.
export const formatJsonTemplate = (value: string): string => {
  const trimmed = value.trim();
  if (trimmed === '') {
    return value;
  }
  const variables: string[] = [];
  let staged = '';
  let index = 0;
  let inString = false;
  while (index < trimmed.length) {
    const char = trimmed[index];
    if (char === '"') {
      // An even run of preceding backslashes (including zero) means the quote is
      // a real boundary; an odd run means it's escaped.
      const before = trimmed.slice(0, index);
      if ((before.length - before.replace(/\\+$/, '').length) % 2 === 0) {
        inString = !inString;
      }
      staged += char;
      index += 1;
      continue;
    }
    VARIABLE.lastIndex = index;
    const match = inString ? null : VARIABLE.exec(trimmed);
    if (match) {
      staged += `"__VARIABLE_${variables.length}__"`;
      variables.push(match[0]);
      index += match[0].length;
      continue;
    }
    staged += char;
    index += 1;
  }
  try {
    const formatted = JSON.stringify(JSON.parse(staged), null, 2);
    return formatted.replace(/"__VARIABLE_(\d+)__"/g, (_, i) => variables[Number(i)]);
  } catch {
    return value;
  }
};
